module.exports = __webpack_public_path__ + "static/media/Formular-Medium.02d3d503.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Formular-Medium.woff
// module id = 275
// module chunks = 0